import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined';
import { PARTNER_BRAND } from '../../partnerDashboardTheme';

const RestoreCommunityDialog = ({ open, communityName, restoring = false, onClose, onConfirm }) => (
  <Dialog
    open={open}
    onClose={restoring ? undefined : onClose}
    PaperProps={{
      sx: {
        borderRadius: 2,
        p: 2,
        textAlign: 'center',
        maxWidth: 400,
        width: '100%',
      },
    }}
  >
    <DialogContent sx={{ pb: 1, pt: 1 }}>
      <Box
        sx={{
          width: 60,
          height: 60,
          borderRadius: '50%',
          bgcolor: '#ecfdf3',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2,
        }}
      >
        <RestoreOutlinedIcon sx={{ fontSize: 32, color: '#16a34a' }} />
      </Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
        Restore Community?
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
        Restore{' '}
        <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
          {communityName || 'this community'}
        </Box>
        ? Members will be able to join and interact again once it is restored.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 1, pt: 2 }}>
      <Button
        variant="outlined"
        disabled={restoring}
        onClick={onClose}
        sx={{
          minWidth: 120,
          height: 44,
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 1.5,
          color: PARTNER_BRAND,
          borderColor: PARTNER_BRAND,
          '&:hover': {
            borderColor: 'primary.dark',
            bgcolor: 'rgba(224, 104, 10, 0.04)',
          },
        }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        disabled={restoring}
        onClick={onConfirm}
        sx={{
          minWidth: 120,
          height: 44,
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 1.5,
          bgcolor: '#16a34a',
          boxShadow: 'none',
          '&:hover': {
            bgcolor: 'success.dark',
            boxShadow: 'none',
          },
        }}
      >
        {restoring ? 'Restoring…' : 'Restore'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default RestoreCommunityDialog;
